module.exports = __webpack_public_path__ + "img/geoguessLogo.4a9f706e.png";